import { BasePostRequest } from './core/basePostRequest';
import * as t from 'io-ts';
import { Authentication } from './core/baseRequest';

export class ModificationRequest extends BasePostRequest<undefined> {
    constructor(public bookingId: string, modificationRequest: string) {
        super(
            `bookings/${bookingId}/request-modification`,
            {},
            {modificationRequest},
            t.undefined,
            Authentication.Login);
    }
}
